/**
 * GOKI-Standard-Text-Tools (TOOL_DEFINITIONS) für das Rezept-Select im
 * Bulk-Wizard — dieselbe Quelle wie AIFieldMenus "Systemvorlagen"-Gruppe.
 *
 * Gleicher Query-Key wie useAIFieldMenuData (AI_FIELD_TOOLS_KEY), damit der
 * Cache projektweit geteilt wird statt doppelt geladen zu werden.
 */

import { useQuery } from '@tanstack/react-query'

import { AI_FIELD_TOOLS_KEY } from '@/hooks/useAIFieldMenuData'
import { fetchTextTools } from '@/components/v2/tools/text/textGenerationApi'

// text_custom ist der Escape-Hatch-Tool-Code mit leerem system_prompt (siehe
// TOOL_DEFINITIONS) — als Stil-Vorlage nutzlos, verhält sich sonst wie "ohne
// Vorlage". Ausblenden statt einen wirkungslosen Eintrag anzuzeigen.
const EMPTY_STYLE_TOOL_CODE = 'text_custom'

export function useSystemTextTools() {
  return useQuery({
    queryKey: AI_FIELD_TOOLS_KEY,
    queryFn: fetchTextTools,
    select: (tools) => tools.filter((tool) => tool.code !== EMPTY_STYLE_TOOL_CODE),
  })
}
